module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/book_detail_04-f3c0174d4ca3ddf2754dda4a3d11425d.png";